<template>
  <v-list-item two-line>
    <v-list-item-content>
      <v-list-item-title class="font-weight-bold primary--text">{{
        usuarioLogado.colaborador
      }}</v-list-item-title>
      <v-list-item-subtitle class="caption font-weight-bold"
        >{{ usuarioLogado.cargo }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn v-if="!gerencial" icon :to="{ name: 'minha-conta' }"
        ><v-icon color="primary" size="23">mdi-account-cog</v-icon></v-btn
      >
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapState } from "vuex";
//import AlterarSenha from "../views/alterarsenha/AlterarSenha.vue";
export default {
  components: {
    /*AlterarSenha*/
  },
  computed: mapState("usuario", ["usuarioLogado","gerencial"]),  
};
</script>
